























































































































import Vue from "vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import { snakeCase } from "lodash";
import HttpClient from "../../../services/HttpClient";
import Sender from "../../../types/invoiceSender/Sender";
import ApiSenderResponse from "../../../types/invoiceSender/api/ApiSenderResponse";
import BaseAlert from "../../../components/black_dashboard_pro/BaseAlert.vue";

export default Vue.extend({
  name: "sender-basic-data-form",
  components: {
    // @ts-ignore
    BaseAlert,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      isLoading: false as boolean,
      emailChanged: false,
      emailNotConfirmedAlert: false,
      resendEmailAlert: false,
      msgAlert: "",
      sender: {
        email: "",
        companyName: "",
        registrationNumber: "",
      } as Sender,
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.loadSenderBasicData();
  },
  methods: {
    changeEmail(event: any) {
      this.emailChanged = event.isTrusted;
    },
    async loadSenderBasicData() {
      try {
        const { data } = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/profiles/v1/me/basic"
        );
        const senderBasicData: ApiSenderResponse = data;
        this.sender.email = senderBasicData.email;
        this.sender.companyName = senderBasicData.companyName;
        this.sender.registrationNumber = senderBasicData.registrationNumber;
      } catch (e) {
        const error: any = {
          text: this.$t("sender:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
    async sendBasicForm() {
      this.isLoading = true;
      try {
        await this.httpClient.put(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/profiles/v1/me/basic",
          this.sender
        );
        if (this.emailChanged) {
          if (localStorage.getItem("rememberCheck")) {
            localStorage.removeItem("rememberCheck");
          }

          this.emailNotConfirmedAlert = true;
          this.msgAlert = this.$t("sender:send_email");
        }

        const success: any = {
          text: this.$t("sender:saved"),
          type: "success",
        };
        this.$notify(success);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;

        const arrayOfErrors: any[] = e.response.data.errors;
        arrayOfErrors.forEach((error: any) => {
          this.showValidationError(
            snakeCase(error.field),
            snakeCase(error.rule)
          );
        });
      }
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("sender:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
